module.exports = __webpack_public_path__ + "img/ib_chemistry.59b51ee0.svg";